import { action } from 'satcheljs';
// IMPORTANT: Do not add any other code here. This is only to define the action. Any orchestrator should be in a different place.
/**
 * Action called whenever an attachment is created
 * @param parentItemId The id of the parent item to which the attachment is attached
 * @param attachmentId The id of the created attachment
 * @param attachment The attachment that was created
 */
export default action('ON_ATTACHMENT_CREATED', function (parentItemId, attachmentId, attachment) {
    return {
        parentItemId: parentItemId,
        attachmentId: attachmentId,
        attachment: attachment,
    };
});
//# sourceMappingURL=onAttachmentCreated.js.map